import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

import { companyAsCreditorLoadTableData, companyAsCreditorTableChange } from '../../actions'

function mapStateToProps(state, hocProps) {
    const tableId = _.get(hocProps, 'tableId', null)
    const module = _.get(hocProps, 'module', null)
    const block = _.get(hocProps, 'block', null)
    const id = _.get(hocProps, 'id', null)

    return {
        data: state.getIn(['ui', 'workspace', module, id, 'blocks', block, 'customData', tableId, 'data'], []),
        isLoading: state.getIn(
            ['ui', 'workspace', module, id, 'blocks', block, 'customData', tableId, 'isLoading'],
            false
        ),
        loaded: state.getIn(['ui', 'workspace', module, id, 'blocks', block, 'customData', tableId, 'loaded'], false),
        pagination: state.getIn(
            ['ui', 'workspace', module, id, 'blocks', block, 'customData', tableId, 'pagination'],
            {}
        ),
        filter: state.getIn(['ui', 'workspace', module, id, 'blocks', block, 'customData', tableId, 'filter'], {}),
        sorted: state.getIn(['ui', 'workspace', module, id, 'blocks', block, 'customData', tableId, 'sorted'], []),
        failed: state.getIn(['ui', 'workspace', module, id, 'blocks', block, 'customData', tableId, 'failed'], false),
        dataLocale: state.getIn(
            ['ui', 'workspace', module, id, 'blocks', block, 'customData', tableId, 'dataLocale'],
            null
        ),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            companyAsCreditorLoadTableData,
            companyAsCreditorTableChange,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
